<div class="role22-form-container">
  <p-toast></p-toast>
  <app-sheet-loader [visible]="isLoading" />

  <p-card [header]="formTitle" [subheader]="isDev ? schema.label : ''" *ngIf="!isLoading && schema && form" class="form-card">

    <div class="bg-gray-200 text-black-700 text-sm font-medium px-2 py-1">Disclosure of notes and other explanatory information</div>

    <form [formGroup]="form">
      <!-- Dynamic Fields and Section Headers -->
      <ng-container *ngFor="let control of schema.controls">
        <!-- Form Fields -->
        <div class="form-field" *ngIf="control.type !== 'SectionHeader' && shouldDisplayField(control)">
          <label class="field-label">
            {{ control.label }}<app-required-marker [when]="isFieldRequired(control)" />
          </label>

          <!-- Text Input -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'text'">
            <input
              type="text"
              pInputText
              [formControlName]="control.qname"
              [placeholder]="control | placeholder"
              class="w-full"
            />

            <small class="error-message"
                   *ngIf="getControl(control.qname)?.invalid && getControl(control.qname)?.touched">
              <span *ngIf="getControl(control.qname)?.errors?.['required']">
                {{ control.label }} is required
              </span>
            </small>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Rich-text (WYSIWYG) field — same preview + pop-out editor as role
               750000 (AS-897 rollout). The control value stays a plain HTML
               string. These fields are all optional, so the required block below
               never fires; it is kept for parity with the shared field pattern. -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'richtext'">
            <app-rich-text-field
              [formControlName]="control.qname"
              [title]="control.label"
              [placeholder]="control | placeholder: 'Click to add content…'"
              [invalid]="!!(getControl(control.qname)?.invalid && getControl(control.qname)?.touched)"
            ></app-rich-text-field>

            <small class="error-message"
                   *ngIf="getControl(control.qname)?.invalid && getControl(control.qname)?.touched">
              <span *ngIf="getControl(control.qname)?.errors?.['required']">
                {{ control.label }} is required
              </span>
            </small>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Number Input -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'number'">
            <p-inputnumber appSchemaNumeric [schemaControl]="control" appNegativeHighlight
              [formControlName]="control.qname"
              [showButtons]="false"
              class="w-full"
            ></p-inputnumber>

            <small class="error-message"
                   *ngIf="getControl(control.qname)?.invalid && getControl(control.qname)?.touched">
              <span *ngIf="getControl(control.qname)?.errors?.['required']">
                {{ control.label }} is required
              </span>
            </small>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

        </div>
      </ng-container>
      <submit-for-validation
      [form]="form"
      [sheetKey]="'notesListOfNotes'"
      [formTitle]="formTitle"
      (cancelConfirmed)="onCancelConfirmed()"
    ></submit-for-validation>
    </form>    
  </p-card>
</div>
